import env from "@/app/config/env";
import type {
  LocalizationAvailableLangType,
  LocalizationDataType,
} from "@/schemas/index";
import {
  LocalizationAvailableLangSchema,
  LocalizationDataSchema,
} from "@/schemas/index";

export interface ServiceLocalizationApiType {
  fetchData: (
    availableLang: LocalizationAvailableLangType,
  ) => Promise<LocalizationDataType>;
  fetchDefaultLang: () => Promise<LocalizationAvailableLangType>;
}

export const serviceLocalizationApi: ServiceLocalizationApiType = {
  fetchDefaultLang: () =>
    Promise.resolve(
      LocalizationAvailableLangSchema.parse(
        localStorage.getItem("lang") || env.app.defaultLang,
      ),
    ),

  fetchData: async (availableLang) => {
    const module = await import("@/app/index");
    return LocalizationDataSchema.parse(
      (module.localization as Record<string, any>)[availableLang] || {},
    );
  },
};
